{
  "name": "mekanic-go",
  "version": "2.47.0",
  "scripts": {
    "ng": "ng",
    "serve": "node node_modules/@angular/cli/bin/ng serve",
    "serve:api:local": "node node_modules/@angular/cli/bin/ng serve --configuration=localhost-api",
    "serve:full:local": "node node_modules/@angular/cli/bin/ng serve --configuration=localhost-full",
    "serve:ssl:local": "node node_modules/@angular/cli/bin/ng serve --configuration=localhost-ssl",
    "serve:ssl:mobile": "node node_modules/@angular/cli/bin/ng serve --configuration=mobile-ssl",
    "start": "ng build",
    "dev": "node log/start.js && ng build --configuration=development && node log/end.js",
    "old-dev": "node log/start.js && ng build --configuration=old-development && node log/end.js",
    "prod": "node log/start.js && ng build --configuration=production && node log/end.js",
    "pilotos": "node log/start.js && ng build --configuration=pilots && node log/end.js",
    "multi": "node log/start.js && ng build --configuration=multi && node log/end.js",
    "dev-multi": "node log/start.js && ng build --configuration=dev-multi && node log/end.js",
    "dev-agro": "node log/start.js && ng build --configuration=dev-agro && node log/end.js",
    "agro": "node log/start.js && ng build --configuration=agro && node log/end.js",
    "dev-dota": "node log/start.js && ng build --configuration=dev-dota && node log/end.js",
    "dota": "node log/start.js && ng build --configuration=dota && node log/end.js",
    "dev-nautical": "node log/start.js && ng build --configuration=dev-nautical && node log/end.js",
    "nautical": "node log/start.js && ng build --configuration=nautical && node log/end.js",
    "log": "node log/read.js",
    "logs": "node log/read.js --5",
    "generate-types": "graphql-codegen --config codegen.yml",
    "test": "jest --config jest.config.js",
    "test:types": "tsc --noEmit -p tsconfig.jest.json --isolatedModules false"
  },
  "private": true,
  "dependencies": {
    "@angular-slider/ngx-slider": "^17.0.1",
    "@angular/animations": "^17.1.0",
    "@angular/cdk": "^17.1.1",
    "@angular/common": "^17.1.0",
    "@angular/compiler": "^17.1.0",
    "@angular/core": "^17.1.0",
    "@angular/fire": "^17.0.1",
    "@angular/forms": "^17.1.0",
    "@angular/material": "^17.1.1",
    "@angular/material-moment-adapter": "^17.2.2",
    "@angular/platform-browser": "^17.1.0",
    "@angular/platform-browser-dynamic": "^17.1.0",
    "@angular/platform-server": "^17.1.0",
    "@angular/router": "^17.1.0",
    "@apollo/client": "^3.11.8",
    "@ctrl/ngx-emoji-mart": "^9.2.0",
    "@emoji-mart/data": "^1.2.1",
    "@graphql-codegen/typescript-apollo-angular": "^4.0.0",
    "@huggingface/inference": "^4.7.1",
    "@langchain/community": "^0.3.55",
    "@langchain/core": "^0.3.75",
    "@langchain/openai": "^0.6.11",
    "@microsoft/clarity": "^1.0.2",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@popperjs/core": "^2.11.8",
    "@swimlane/ngx-charts": "^20.5.0",
    "@types/jsbarcode": "^3.11.4",
    "@zxing/browser": "^0.1.5",
    "@zxing/library": "^0.21.3",
    "angular-calendar": "^0.31.0",
    "apollo-angular": "^7.2.1",
    "assemblyai": "^4.12.2",
    "chart.js": "^4.4.7",
    "chartjs-plugin-datalabels": "^2.2.0",
    "cropperjs": "^1.6.1",
    "crypto-js": "^4.2.0",
    "date-fns": "^3.3.1",
    "decimal.js": "^10.5.0",
    "dexie": "^4.0.11",
    "dom-to-image": "^2.6.0",
    "dompurify": "^3.4.11",
    "echarts": "^5.5.0",
    "emoji-mart": "^5.6.0",
    "express": "^4.18.2",
    "extenso": "^2.1.0",
    "file-saver": "^2.0.5",
    "firebase": "^10.7.2",
    "graphql": "^16.9.0",
    "html2canvas": "^1.4.1",
    "jsbarcode": "^3.12.1",
    "jspdf": "^2.5.1",
    "jspdf-autotable": "^3.8.2",
    "jszip": "^3.10.1",
    "karma-coverage-istanbul-reporter": "^3.0.3",
    "langchain": "^0.3.33",
    "luxon": "^3.4.4",
    "marked": "^9.1.6",
    "mekanic-go": "file:",
    "moment": "^2.30.1",
    "ng-lottie": "^0.3.2",
    "ngx-countdown": "^17.1.1",
    "ngx-device-detector": "^7.0.0",
    "ngx-image-compress": "^15.1.6",
    "ngx-markdown": "^17.1.1",
    "ngx-material-timepicker": "^13.1.1",
    "openai": "^4.100.0",
    "pdfmake": "^0.2.10",
    "punycode": "^2.3.1",
    "rxjs": "~7.8.0",
    "showdown": "^2.1.0",
    "smart-webcomponents": "^18.0.26",
    "smart-webcomponents-angular": "^18.0.2",
    "t5-common": "^1.0.8",
    "timers": "^0.1.1",
    "together-ai": "^0.16.0",
    "tslib": "^2.3.0",
    "uuid": "^10.0.0",
    "xlsx": "^0.18.5",
    "xml2js": "^0.6.2",
    "zod": "^3.25.32",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.1.1",
    "@angular/cli": "^17.1.1",
    "@angular/compiler-cli": "^17.1.0",
    "@angular/language-service": "^20.1.0",
    "@graphql-codegen/cli": "^5.0.3",
    "@graphql-codegen/typescript": "^4.1.0",
    "@graphql-codegen/typescript-operations": "^4.3.0",
    "@types/crypto-js": "^4.2.2",
    "@types/dom-to-image": "^2.6.7",
    "@types/dompurify": "^3.2.0",
    "@types/emoji-mart": "^3.0.14",
    "@types/express": "^4.17.17",
    "@types/jasmine": "~5.1.0",
    "@types/jest": "^29.5.14",
    "@types/jest-axe": "^3.5.9",
    "@types/node": "^18.19.39",
    "@types/pdfmake": "^0.2.9",
    "@types/uuid": "^10.0.0",
    "@types/xml2js": "^0.4.14",
    "dotenv": "^16.5.0",
    "jasmine-core": "~5.1.0",
    "jest": "^29.7.0",
    "jest-axe": "^11.0.0",
    "jest-preset-angular": "^14.5.5",
    "json-server": "^1.0.0-beta.1",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ts-jest": "^29.2.5",
    "typescript": "~5.3.2"
  },
  "optionalDependencies": {
    "@esbuild/linux-x64": "^0.21.3"
  }
}
